// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullAccordion {
    flex-direction: column;
    align-items: flex-start;
}

.FullAccordion-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    padding-top: 100px;
    padding-bottom: 60px;
}

.FullAccordion-content {
    width: 100%;
}

.full-collapse {
    width: 100%;
}

.full-collapse .ant-collapse-header {
    font-size: 1rem;
    padding: 18px 16px !important;
    border-bottom: 1px solid #9a878726;
    font-family: Poppins;
}

.full-collapse .ant-collapse-header-text {
    font-size: 26px;
}

.full-collapse svg {
    padding-top: 20px;
}

.full-collapse .ant-collapse-content-box {
    font-size: 16px;
}

.full-collapse.ant-collapse-item {
    border-bottom: 1px solid #9a878726;
}`, "",{"version":3,"sources":["webpack://./src/css/FullAccordion.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".FullAccordion {\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.FullAccordion-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n    padding-top: 100px;\n    padding-bottom: 60px;\n}\n\n.FullAccordion-content {\n    width: 100%;\n}\n\n.full-collapse {\n    width: 100%;\n}\n\n.full-collapse .ant-collapse-header {\n    font-size: 1rem;\n    padding: 18px 16px !important;\n    border-bottom: 1px solid #9a878726;\n    font-family: Poppins;\n}\n\n.full-collapse .ant-collapse-header-text {\n    font-size: 26px;\n}\n\n.full-collapse svg {\n    padding-top: 20px;\n}\n\n.full-collapse .ant-collapse-content-box {\n    font-size: 16px;\n}\n\n.full-collapse.ant-collapse-item {\n    border-bottom: 1px solid #9a878726;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
